const CURRENCY = ["ZIG", "USD"]

export default CURRENCY